module.exports = __webpack_public_path__ + "static/media/carpet-cleaning-service-icon.d450f8b3.svg";